import { createContext } from "react";

const PoolContext = createContext({})

export default PoolContext;